module.exports = __webpack_public_path__ + "static/media/7C.61d66fba.svg";